module.exports = __webpack_public_path__ + "img/figure-6.ddd87c79.png";